import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var debug = process.env.NODE_ENV !== 'production'

var state = {
  siteRoot: window.pageData.siteRoot,
  localizedStrings: window.pageData.localizedStrings || {},
  viewModel: null,
  occasions: [],
  occasionsLoaded: false,
  selectedOccasion: null,
  occasionQuery: '',
  participants: [],
  participantQuery: '',
  selectedParticipant: null,
  postalCode: '',
  validationAttempted: false,
  participantSearchLoading: false
}

var getters = {
  requiresSecurity: function (state) {
    if (state.selectedOccasion) {
      return state.selectedOccasion.requiresAdditionalSecurity === true
    }
    return false
  },
  hasSelectedOccasionFromServer: function (state) {
    return state.viewModel && state.viewModel.selectedOccasion !== null
  },
  occasionHasHappened: function (state) {
    if (state.selectedOccasion && state.selectedOccasion.occasionDate) {
      return new Date() > new Date(state.selectedOccasion.occasionDate)
    }
    return true
  },
  occasionValid: function (state, getters) {
    if (getters.hasSelectedOccasionFromServer) {
      return true
    }
    return state.selectedOccasion !== null
  },
  participantValid: function (state) {
    var participantInput = state.selectedParticipant !== null || state.participantQuery.length > 0
    return participantInput
  },
  postalCodeValid: function (state, getters) {
    if (!getters.requiresSecurity) {
      return true
    }
    return state.postalCode.length > 0
  },
  requiresExactMatch: function (state) {
    return state.selectedOccasion && state.selectedOccasion.requireExactMatch === true
  },
  exactMatchInputValid: function (state, getters) {
    if (!getters.requiresExactMatch) {
      return true
    }
    var input = state.participantQuery
    if (!input || input.length === 0) {
      return true
    }
    var isBibNumber = /^[0-9]+$/.test(input)
    var hasFullName = input.indexOf(' ') !== -1 || input.indexOf(',') !== -1
    return isBibNumber || hasFullName
  },
  formValid: function (state, getters) {
    return getters.occasionValid && getters.participantValid && getters.postalCodeValid && getters.exactMatchInputValid
  }
}

var mutations = {
  setViewModel: function (state, value) {
    state.viewModel = value
    if (value && value.selectedOccasion) {
      state.selectedOccasion = value.selectedOccasion
    }
  },
  setOccasions: function (state, value) {
    state.occasions = value
    state.occasionsLoaded = true
  },
  setSelectedOccasion: function (state, value) {
    state.selectedOccasion = value
    // Reset participant state when occasion changes
    state.participants = []
    state.participantQuery = ''
    state.selectedParticipant = null
    state.postalCode = ''
    state.validationAttempted = false
  },
  setOccasionQuery: function (state, value) {
    state.occasionQuery = value
  },
  setParticipants: function (state, value) {
    state.participants = value
  },
  setParticipantQuery: function (state, value) {
    state.participantQuery = value
  },
  setSelectedParticipant: function (state, value) {
    state.selectedParticipant = value
  },
  setPostalCode: function (state, value) {
    state.postalCode = value
  },
  setValidationAttempted: function (state, value) {
    state.validationAttempted = value
  },
  setParticipantSearchLoading: function (state, value) {
    state.participantSearchLoading = value
  }
}

var actions = {
  fetchOccasions: function (context) {
    return axios.get(context.state.siteRoot + 'FindMyPhotosApi/Occasions')
      .then(function (response) {
        context.commit('setOccasions', response.data)
      })
  },
  prefetchParticipants: function (context, occasionRef) {
    if (context.getters.requiresExactMatch) {
      return
    }
    // Fire-and-forget to warm the server-side cache
    axios.get(context.state.siteRoot + 'FindMyPhotosApi/ParticipantsPrefetch', {
      params: { occasionRef: occasionRef }
    })
  },
  searchParticipants: function (context, payload) {
    if (context.getters.requiresExactMatch) {
      context.commit('setParticipants', [])
      return
    }
    context.commit('setParticipantSearchLoading', true)
    return axios.get(context.state.siteRoot + 'FindMyPhotosApi/ParticipantsSearch', {
      params: { occasionRef: payload.occasionRef, searchString: payload.searchString }
    })
      .then(function (response) {
        context.commit('setParticipants', response.data)
      })
      .finally(function () {
        context.commit('setParticipantSearchLoading', false)
      })
  }
}

export default new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  strict: debug
})



// WEBPACK FOOTER //
// ./WebResources/vue/find-my-photos/store.js